import React from 'react';
import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/auth';
import { routePaths } from '../../routePaths';
import { LocationState, PublicRouteProps } from './types';

const PublicRoute = ({ component, ...rest }: PublicRouteProps) => {
    const { user } = useAuth();
    const { pathname, state } = useLocation<LocationState>();
    const { referrer } = state || { referrer: routePaths.dashboard };
    const Component = component;

    return (
        <Route
            {...rest}
            render={(props: RouteProps) => (
            !user ?
                <Component {...props} />
            : (
                <Redirect
                    to={{
                pathname: referrer,
                state: { referrer: pathname }
              }}
                />
          )
          )}
        />
    );
};

export default PublicRoute;
